import React from 'react';
import _ from 'lodash';
import { process } from '../../libs/entityLogs';
import clsx from 'classnames';

import ErrorIcon from '@material-ui/icons/Error';
import { withStyles } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function styles() {
	return {
		container: {
			//marginTop: 10,
			marginBottom: 20,
			border: `1px solid #E57373`,
			//padding: 10,
			backgroundColor: '#fcfcfc',
			boxShadow: 'none',
		},
		iconContainer: {
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			fontWeight: 500,
			color: '#333',
		},
		errorIcon: {
			color: '#F44336',
			marginRight: 10,
		},
	};
}

class CalendarProblems extends React.PureComponent {
	render() {
		const { searchResult, locationIds, classes, expanded } = this.props;

		const calendarProblems = _.get(searchResult, 'workDayProblems', []);

		if (_.isEmpty(calendarProblems)) {
			return null;
		}

		let problemsAtOtherTerminals = 0;
		const calendarProblemsAtThisTerminal = [];

		calendarProblems.forEach((calendarProblem) => {
			const { locationId } = calendarProblem;
			if (locationId) {
				if (!_.includes(locationIds, locationId)) {
					problemsAtOtherTerminals++;
					return;
				}
			}
			calendarProblemsAtThisTerminal.push(calendarProblem);
		});

		if (_.isEmpty(calendarProblemsAtThisTerminal)) {
			return null;
		}
		return (
			<Accordion
				onChange={this.props.onChange}
				expanded={expanded}
				className={clsx(classes.globalMainPaper, classes.container)}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<div className={classes.iconContainer}>
						<ErrorIcon className={classes.errorIcon} />
						Calendar Conflicts :&nbsp;
						<strong>{calendarProblemsAtThisTerminal.length} Issues Detected</strong>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					<div>
						<ul style={{ lineHeight: 1.5, marginTop: 0 }}>
							{calendarProblemsAtThisTerminal.map((calendarProblem, i) => {
								const { locationId } = calendarProblem;
								if (locationId) {
									if (!_.includes(locationIds, locationId)) {
										problemsAtOtherTerminals++;
										return null;
									}
								}
								return <li key={i}>{process(calendarProblem)}</li>;
							})}
						</ul>

						{!!problemsAtOtherTerminals && (
							<div>There are {problemsAtOtherTerminals} calendar conflicts at other terminals.</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>
		);
	}
}
export default withStyles(styles)(CalendarProblems);
